import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class AmendedCycleService {

  constructor(private http: HttpClient) { }

  /**
   * Save Amended Cycle Form following the standardized pattern
   * @param baseUrl - Base URL from GENERAL_CONFIG
   * @param amendedCycleData - The amended cycle data to save
   * @param globalService - Global service parameters
   * @param filterParams - Filter parameters from AngularJS
   * @param rowData - Row data from AngularJS
   */
  saveAmendedCycleForm(
    baseUrl: string,
    amendedCycleData: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // Build settings object
    const settingsObj = {
      tax_year: filterParams.tax_year || globalService?.tax_year || amendedCycleData.TAX_YEAR
    };

    // Build payload EXACTLY like original AngularJS
    let params = _.merge({}, globalService || {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(amendedCycleData) }, params);
    params = _.extend({ clob_settings: JSON.stringify(settingsObj) }, params);

    // Set required parameters
    params.is_issue_key_enabled = 'N';
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";

    // Build checkLockedbj from data (combination_key and scenario_key)
    const checkLockedbj = [{
      "combination_key": amendedCycleData.COMBINATION_KEY || rowData.COMBINATION_KEY || 676,
      "scenario_key": parseInt(filterParams.scenario || params.scenario || 74)
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Build URL with action code (matching original AngularJS: action_code=0087ar)
    const url = `${baseUrl}/saveJsonObject?action_code=0087ar`;

    // CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlEncoded.set(key, params[key]);
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}

